"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createRoutesProxy = void 0;
const ObjectHelper_1 = require("./ObjectHelper");
const createRoutesProxy = (target) => {
    const getCallIdentifier = (methodName, args) => {
        return `${methodName}:${JSON.stringify(args)}`;
    };
    const handleTargetPromise = (target, callIdentifier, promise) => {
        return promise
            .then((result) => {
            return Promise.resolve(result);
        })
            .catch((error) => {
            return Promise.reject(error);
        })
            .finally(() => {
            delete target.promiseStack[callIdentifier];
        });
    };
    const proxyTarget = {
        ...target,
        methods: (0, ObjectHelper_1.getMethodsInTarget)(target),
        promiseStack: {},
    };
    const proxyHandler = {
        get: function (apiTarget, apiMethodName) {
            if (apiMethodName in apiTarget) {
                return (...args) => {
                    var _a;
                    const callIdentifier = getCallIdentifier(apiMethodName, args);
                    if (callIdentifier in apiTarget.promiseStack) {
                        return ((_a = apiTarget.promiseStack[callIdentifier]) === null || _a === void 0 ? void 0 : _a.promise) || Promise.resolve();
                    }
                    const newPromise = {
                        promise: apiTarget.methods[apiMethodName](...args),
                    };
                    apiTarget.promiseStack[callIdentifier] = newPromise;
                    return handleTargetPromise(apiTarget, callIdentifier, newPromise.promise);
                };
            }
            return undefined;
        },
    };
    return new Proxy(proxyTarget, proxyHandler);
};
exports.createRoutesProxy = createRoutesProxy;
